/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:30:13
 * @LastEditTime: 2024-05-10 16:25:52
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\work-center\modules\dataReportRouter.js
 * 数据上报
 */
const dataReportRouter = [
  // 数据上报
  {
    path: '/behaviorManage/data-report/page',
    name: 'behaviorManageDataReportPage',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
      //   '@/views/behaviorManage/data-report/Page'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
        '@/views/behavior-manage/work-center/data-report/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '数据上报', //二级菜单
      title: '数据上报'
    }
  },
  // 数据上报
  {
    path: '/behaviorManage/data-report-total/page',
    name: 'behaviorManageDataReportTotalPage',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
      //   '@/views/behaviorManage/data-report/Page'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
        '@/views/behavior-manage/work-center/data-report-total/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '数据上报', //二级菜单
      title: '纯销自报汇总表'
    }
  },
  // 数据上报快捷填报
  {
    path: '/behaviorManage/data-report-total-bat/page',
    name: 'behaviorManageDataReportTotalBatPage',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
      //   '@/views/behaviorManage/data-report/Page'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
        '@/views/behavior-manage/work-center/data-report-total/Edit.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '数据上报', //二级菜单
      title: '快捷填报',
      breadcrumb: [
        {
          title: '纯销自报汇总表',
          name: 'behaviorManageDataReportTotalPage'
        }
      ]
    }
  },
  // 数据上报填报数据
  {
    path: '/behaviorManage/dataReportFilling/:template_id/:id/:report_date_id/:type/:tabName',
    name: 'DataReportFilling',
    component: () =>
      //   import(
      //     /*webpackChunkName:"behaviorManageVisitIndex" */
      //     '@/views/behaviorManage/data-report/dataReportFilling.vue'
      //   ), //待删除文件
      import(
        /*webpackChunkName:"behaviorManageVisitIndex" */
        '@/views/behavior-manage/work-center/data-report/Edit.vue'
      ), //新迁移文件
    meta: {
      title: '创建数据上报', //二级菜单
      isMoreMeta: true,
      breadcrumb: [
        {
          title: '数据上报',
          name: 'behaviorManageDataReportPage'
        }
      ]
    }
  },
  // 数据上报导入数据
  {
    path: '/behaviorManage/dataReportImport/:id/:report_date_id/:report_text/:clsList/:cycle_dimension',
    name: 'DataReportImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageVisitIndex" */
      //   '@/views/behaviorManage/data-report/dataReportImport.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageVisitIndex" */
        '@/views/behavior-manage/work-center/data-report/Import.vue'
      ), //新迁移文件
    meta: {
      title: '导入数据上报', //二级菜单
      isMoreMeta: true,
      breadcrumb: [
        {
          title: '数据上报',
          name: 'behaviorManageDataReportPage'
        }
      ]
    }
  },
  // 数据上报导入数据
  {
    path: '/behaviorManage/dataReportImportHistory/:id/:report_date_id/:report_text/:clsList/:cycle_dimension',
    name: 'DataReportImportHistory',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageVisitIndex" */
      //   '@/views/behaviorManage/data-report/dataReportImport.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageVisitIndex" */
        '@/views/behavior-manage/work-center/data-report/ImportHistory.vue'
      ), //新迁移文件
    meta: {
      title: '导入历史数据上报', //二级菜单
      isMoreMeta: true,
      breadcrumb: [
        {
          title: '数据上报',
          name: 'behaviorManageDataReportPage'
        }
      ]
    }
  },
  // 数据上报  详情
  {
    path: '/behaviorManage/dataReportDetail/:id/:report_date_id',
    name: 'DataReportDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageNewHospitalExploit" */
      //   '@/views/behaviorManage/data-report/Detail.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageNewHospitalExploit" */
        '@/views/behavior-manage/work-center/data-report/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '数据上报', //二级菜单
      title: '数据上报详情',
      breadcrumb: [
        {
          title: '数据上报',
          name: 'behaviorManageDataReportPage'
        }
      ]
    }
  },

  // 数据上报  详情
  {
    path: '/behaviorManage/dataReportInstall/:id/:type',
    name: 'DataReportInstall',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageNewHospitalExploit" */
      //   '@/views/behaviorManage/data-report/Detail.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageNewHospitalExploit" */
        '@/views/behavior-manage/work-center/data-report/Install.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '数据上报', //二级菜单
      title: '期初设置',
      breadcrumb: [
        {
          title: '数据上报',
          name: 'behaviorManageDataReportPage'
        }
      ],
      isMoreMeta: true,
      1: {
        title: '期初设置'
      },
      2: {
        title: '期初库存'
      }
    }
  },

  // 数据上报 新增报表
  {
    path: '/behaviorManage/data-report-form/page/:id',
    name: 'behaviorManageDataReportFormPage',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManageDoctorsEstimatePage" */
        '@/views/behavior-manage/work-center/data-report-form/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '数据上报', //二级菜单
      title: '',
      breadcrumb: []
    }
  }
]
export default dataReportRouter
